import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useTranslation } from 'react-i18next';
import { useDocImage } from '../hooks/useDocImage';

export default function CookiePolicy() {
  const { t } = useTranslation();
  const image001 = useDocImage('cookie-policy-img', 'image001.png');
  const image002 = useDocImage('cookie-policy-img', 'image002.png');
  const image003 = useDocImage('cookie-policy-img', 'image003.png');
  const image004 = useDocImage('cookie-policy-img', 'image004.png');
  const image005 = useDocImage('cookie-policy-img', 'image005.png');
  const image006 = useDocImage('cookie-policy-img', 'image006.png');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.cookiePolicy.title')}</h1>
            <p className="header-para">{t('documentation.cookiePolicy.intro')}</p>
            <img src={image002} alt={t('documentation.cookiePolicy.overview.imageAlt')} className="img-fluid pt-10 pb-30" />

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.cookiePolicy.accessing.title')}
              </div>
              <div className="card-body">
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.cookiePolicy.accessing.steps.step1') }}></li>
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: t('documentation.cookiePolicy.accessing.steps.step2') }}></span>
                    <img src={image001} alt={t('documentation.cookiePolicy.accessing.imageAlt')} className="doc-img-native pb-10 pt-10" />
                  </li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.cookiePolicy.accessing.steps.step3') }}></li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.cookiePolicy.overview.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.cookiePolicy.overview.desc')}</p>
                <p className="alert alert-info mb-0 mt-3">{t('documentation.cookiePolicy.overview.orgNote')}</p>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.cookiePolicy.footerToggle.title')}
              </div>
              <div className="card-body">
                <img src={image003} alt={t('documentation.cookiePolicy.footerToggle.imageAlt')} className="img-fluid pt-10 pb-20" />
                <ul>
                  <li>{t('documentation.cookiePolicy.footerToggle.items.item1')}</li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.cookiePolicy.footerToggle.items.item2') }}></li>
                  <li>{t('documentation.cookiePolicy.footerToggle.items.item3')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.cookiePolicy.editor.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.cookiePolicy.editor.intro')}</p>
                <img src={image004} alt={t('documentation.cookiePolicy.editor.imageAlt')} className="img-fluid pt-10 pb-20" />
                <p><b>{t('documentation.cookiePolicy.editor.formattingTitle')}</b></p>
                <ul>
                  <li>{t('documentation.cookiePolicy.editor.formattingItems.item1')}</li>
                  <li>{t('documentation.cookiePolicy.editor.formattingItems.item2')}</li>
                  <li>{t('documentation.cookiePolicy.editor.formattingItems.item3')}</li>
                  <li>{t('documentation.cookiePolicy.editor.formattingItems.item4')}</li>
                </ul>
                <p className="mt-3"><b>{t('documentation.cookiePolicy.editor.tablesTitle')}</b></p>
                <ul>
                  <li>{t('documentation.cookiePolicy.editor.tableItems.item1')}</li>
                  <li>{t('documentation.cookiePolicy.editor.tableItems.item2')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.cookiePolicy.bannerSettings.title')}
              </div>
              <div className="card-body">
                <img src={image005} alt={t('documentation.cookiePolicy.bannerSettings.imageAlt')} className="img-fluid pt-10 pb-20" />
                <ul>
                  <li>{t('documentation.cookiePolicy.bannerSettings.items.accept')}</li>
                  <li>{t('documentation.cookiePolicy.bannerSettings.items.reject')}</li>
                  <li>{t('documentation.cookiePolicy.bannerSettings.items.customLabels')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.cookiePolicy.saving.title')}
              </div>
              <div className="card-body">
                <img src={image006} alt={t('documentation.cookiePolicy.saving.imageAlt')} className="doc-img-native pt-10 pb-20" />
                <ul>
                  <li>{t('documentation.cookiePolicy.saving.items.item1')}</li>
                  <li>{t('documentation.cookiePolicy.saving.items.item2')}</li>
                </ul>
              </div>
            </div>

            <p className="alert alert-info mb-0">{t('documentation.cookiePolicy.permissionsNote')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
